<template>
  <section class="hero-wrapper">
    <video
      v-if="videoBlobUrl"
      autoplay
      loop
      muted
      class="hero-video"
      preload="auto"
    >
      <source :src="videoBlobUrl" type="video/mp4" />
      متصفحك لا يدعم تشغيل الفيديو.
    </video>

    <div class="hero-overlay"></div>

    <div class="hero-content glass-panel">
      <div class="hero-heading" >
        <p class="chip">
          {{ $t('hero.tagline') }}
        </p>

        <transition name="fade">
          <h1
            v-if="showText"
            key="text"
            class="hero-title"
          >
            {{ currentText }}
          </h1>
        </transition>

        <p class="hero-subtitle">
          {{ $t('hero.description') }}
        </p>
      </div>

      <div class="hero-cta">
        <router-link to="/contact" class="primary-button">
          {{ $t('buttons.getStarted') }}
        </router-link>
        <router-link to="/about" class="secondary-button">
          {{ $t('buttons.learnMore') }}
        </router-link>
      </div>

      <div class="hero-metrics">
        <div
          v-for="metric in heroHighlights"
          :key="metric.label"
          class="metric-card"
        >
          <p class="metric-value">{{ metric.value }}</p>
          <p class="metric-label">{{ metric.label }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useVideoStore } from "@/stores/videoStroe.js";
import localVideo from '@/assets/Backend/vedio.webm';

const { t } = useI18n();
const videoStore = useVideoStore();
const videoBlobUrl = ref(null);

const texts = computed(() => [
  t('slogans.slogan1'),
  t('slogans.slogan2'),
  t('slogans.slogan3'),
  t('slogans.slogan4')
]);

const heroHighlights = computed(() => [
  { value: '25K+', label: t('Statistics.progress') },
  { value: '90K m²', label: t('Statistics.plotArea') },
  { value: '56', label: t('Statistics.projectsCompleted') },
]);

const currentTextIndex = ref(0);
const currentText = ref(texts.value[currentTextIndex.value]);
const showText = ref(true);

let intervalId; // تعريف intervalId في النطاق العام لـ setup

onMounted(async () => {
  try {
    // Use local video directly
    videoBlobUrl.value = localVideo;
    await videoStore.loadVideo(videoBlobUrl.value);
  } catch (error) {
    console.error('Failed to load video:', error);
  }

  intervalId = setInterval(() => {
    showText.value = false;
    setTimeout(() => {
      currentTextIndex.value = (currentTextIndex.value + 1) % texts.value.length;
      currentText.value = texts.value[currentTextIndex.value];
      showText.value = true;
    }, 500); // مدة أقصر للتلاشي
  }, 5000);
});

onUnmounted(() => {
  clearInterval(intervalId);
});
</script>

<style scoped>
.hero-wrapper {
  position: relative;
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8rem 1.5rem 4rem;
  overflow: hidden;
}

.hero-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.55);
  z-index: -2;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(120deg, rgba(16, 16, 16, 0.75), rgba(16, 16, 16, 0.35));
  z-index: -1;
}

.hero-content {
  max-width: 860px;
  padding: clamp(2.5rem, 4vw, 3.5rem);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 2rem;
   background-color: inherit; /* or specify your desired color with transparency */
  opacity: 0.8; /* This affects the entire element's opacity */
}

.hero-title {
  font-size: clamp(2.75rem, 6vw, 4.5rem);
  color: #fff;
  margin: 1rem 0;
  font-weight: 700;
  line-height: 1.1;
  text-shadow: 0 18px 45px rgba(0, 0, 0, 0.6);
}

.hero-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.05rem;
  margin: 0;
}

.hero-cta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

.hero-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 0.85rem;
}

.metric-card {
  padding: 1rem 1.25rem;
  border-radius: 18px;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-align: left;
}

.metric-value {
  margin: 0;
  color: #fff;
  font-size: 1.85rem;
  font-weight: 700;
}

.metric-label {
  margin: 0.35rem 0 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

@media (max-width: 640px) {
  .hero-content {
    padding: 2rem;
  }
}
</style>
